import React, { useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { Routes } from "../routes";

export default () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleInstallPrompt = (event) => {
      event.preventDefault();
      setDeferredPrompt(event);
    };
    window.addEventListener("beforeinstallprompt", handleInstallPrompt);
    return () => window.removeEventListener("beforeinstallprompt", handleInstallPrompt);
  }, []);

  const handleInstallClick = async () => {
    if (!deferredPrompt) {
      return;
    }
    deferredPrompt.prompt();
    await deferredPrompt.userChoice;
    setDeferredPrompt(null);
  };

  return (
    <main>
      <section className="d-flex align-items-center my-5 mt-lg-6 mb-lg-5">
        <Container>
          <Row className="justify-content-center">
            <Col xs={12} md={8} lg={6}>
              <Card border="light" className="shadow-sm">
                <Card.Body className="text-center p-4 p-lg-5">
                  <h3 className="mb-3">WekaRecords</h3>
                  <p className="text-muted mb-4">
                  Effortlessly track M-PESA, cash, and group records in one secure dashboard.
                  Build transparency and trust with WekaRecords
                  </p>
                  <div className="d-flex justify-content-center gap-2">
                    <Button as={Link} to={Routes.Signin.path} variant="primary">
                      Sign in
                    </Button>
                    <Button as={Link} to={Routes.Signup.path} variant="outline-primary">
                      Create account
                    </Button>
                    {deferredPrompt ? (
                      <Button variant="outline-secondary" onClick={handleInstallClick}>
                        Install
                      </Button>
                    ) : null}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </section>
    </main>
  );
};
